import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = comprobando, false = fuera, object = dentro

  useEffect(() => {
    const token = localStorage.getItem("ca_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("ca_token");
        setUser(false);
      });
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("ca_token", res.data.token);
      // v13: /auth/me trae también el plan y si la cuenta es madre o depende de un equipo Business.
      const me = await api.get("/auth/me").catch(() => null);
      setUser(me?.data || res.data.user);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: apiError(err, "Correo o contraseña incorrectos.") };
    }
  }, []);

  const register = useCallback(async (name, email, password, acceptTerms = true, planInterest = "") => {
    try {
      const res = await api.post("/auth/register", { name, email, password, accept_terms: acceptTerms,
        ...(planInterest ? { plan_interest: planInterest } : {}) });
      localStorage.setItem("ca_token", res.data.token);
      const me = await api.get("/auth/me").catch(() => null);
      setUser(me?.data || res.data.user);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: apiError(err, "No hemos podido crear la cuenta.") };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("ca_token");
    setUser(false);
  }, []);

  // v9: tras cambiar el correo en «Cuenta», el servidor devuelve una sesión nueva.
  const updateSession = useCallback((token, u) => {
    if (token) localStorage.setItem("ca_token", token);
    setUser((prev) => ({ ...(prev || {}), ...u }));
  }, []);

  return <AuthContext.Provider value={{ user, login, register, logout, updateSession }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
